import {Navigate, useLocation} from 'react-router';

/**
 * A redirect that keeps the query and the hash: an old
 * /app/forecast-maps?config=7 link is for map 7 (#327 MR8).
 */
const RedirectKeepingSearch = ({to}: {to: string}) => {
  const {search, hash} = useLocation();
  return <Navigate to={{pathname: to, search, hash}} replace />;
};

export default RedirectKeepingSearch;
